<template>
  <main id="main">
    <div class="header_page">
      <p id="title_header_page">مضامین دوره</p>
      <img id="arrow_back_page" src="@/assets/imgs/back.svg" alt="" @click="$router.go(-1)">
    </div>

    <div class="p-3" id="items-container">
      <div v-if="loading" class="d-flex justify-content-center mt-5">
        <p>در حال دریافت معلومات...</p>
      </div>
      
      <div v-else-if="errorMessage" class="d-flex justify-content-center mt-5 text-center">
        <p class="text_color_red bold">{{ errorMessage }}</p>
      </div>

      <div v-else>
        <div v-for="(lesson, index) in lessons" :key="index" class="d-flex align-items-center gap-3 mb-3 item" @click="handleLessonClick(lesson)">
          <div class="position-relative">
            <p style="width: 3rem; height: 3rem" :class="['rounded-pill d-flex align-items-center justify-content-center', !lesson.is_access ? 'bg_box_theme' : 'bg_light_theme']">
              <img :src="!lesson.is_access ? require('@/assets/imgs/lock.svg') : require('@/assets/imgs/unlock.svg')" class="icon-size-1" alt="">
            </p>
            <p class="hr_vertical"></p>
          </div>

          <div class="bg_white rounded-4 d-flex align-items-center justify-content-between p-3 shadow_box w-95">
            <div>
              <div class="d-flex align-items-center gap-3">
                <p>{{ lesson.title }}</p>
                <p class="text_color_gray">{{ lesson.second_title }}</p>
              </div>
            </div>
            <div class="d-flex align-items-center gap-4">
              <p class="text_color_gray">{{ lesson.time }}</p>
              <img src="@/assets/imgs/play.svg" class="icon-size-4" alt="">
            </div>
          </div>
        </div>
        
        <div v-if="lessons.length === 0" class="text-center mt-4 text_color_gray">
          محتوایی برای این مضمون یافت نشد.
        </div>
      </div>
    </div>

    <div v-if="showAccessDeniedModal" class="modal_overlay">
      <div class="modal_content">
        <div class="d-flex justify-content-center mb-3 position-relative">
           <div class="icon_circle">
             <img src="@/assets/imgs/folder (1).svg" class="modal_img" alt="">
           </div>
        </div>
        <p class="text-center font_normal mb-5 line_height_2 px-2 mt-4">مشاهده این محتوا پس از نمره کامیابی در مضامین قبلی برای شما ممکن است</p>
        <button class="modal_btn" @click="closeAccessDeniedModal">فهمیدم</button>
      </div>
    </div>
  </main>
</template>

<script>
import apiClient, { createFormData } from '@/services/api'

export default {
  name: 'CourseLessonsView',
  data() {
    return {
      lessons: [],
      loading: false,
      errorMessage: '',
      showAccessDeniedModal: false
    }
  },
  mounted() {
    this.fetchLessons()
  },
  methods: {
    async fetchLessons() {
      const lessonId = this.$route.params.lessonId
      if (!lessonId) return

      const userId = localStorage.getItem('user_id')

      this.loading = true
      this.errorMessage = ''
      this.lessons = []

      try {
        const formData = createFormData({
          user_id: userId,
          lesson_id: lessonId
        })

        const response = await apiClient.post('/lessons_content', formData)

        if (response.data.status === 'ok' && response.data.data) {
          this.lessons = response.data.data
        } else {
          this.errorMessage = response.data.message || 'مشکل در دریافت معلومات'
        }
      } catch (error) {
        console.error(error)
        this.errorMessage = 'مشکل در برقراری ارتباط با سرور'
      } finally {
        this.loading = false
      }
    },
    handleLessonClick(lesson) {
      if (lesson.is_access) {
        this.goToDetail(lesson)
      } else {
        this.showAccessDeniedModal = true
      }
    },
    goToDetail(lesson) {
      this.$router.push({ 
        name: 'LessonDetail', 
        params: { id: lesson.content_id } 
      })
    },
    closeAccessDeniedModal() {
      this.showAccessDeniedModal = false
    }
  }
}
</script>

<style scoped>
.hr_vertical {
  width: 1px;
  height: 5rem;
  position: absolute;
  border: 1px dashed var(--bg_light_theme);
  left: 50%;
  transform: translate(-50%, -0.9rem);
}
.item:not(:last-child) .hr_vertical {
  display: block;
}
.item:last-child .hr_vertical,
.item:only-child .hr_vertical {
  display: none;
}
.modal_overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal_content {
  background-color: white;
  width: 85%;
  max-width: 25rem;
  border-radius: 2.5rem;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
  animation: fadeIn 0.3s ease-out;
}
.icon_circle {
  background-color: white;
  border-radius: 50%;
  padding: 1rem;
  width: 7rem;
  height: 7rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -4rem;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
}
.modal_img {
  width: 4rem;
  height: 4rem;
}
.modal_btn {
  background: linear-gradient(90deg, #8E2DE2 0%, #4A00E0 100%);
  color: white;
  border: none;
  border-radius: 50px;
  padding: 1rem 0;
  font-weight: bold;
  font-size: 1.1rem;
  box-shadow: 0 5px 15px rgba(74, 0, 224, 0.4);
  cursor: pointer;
  width: 100%;
  transition: transform 0.2s;
}
.modal_btn:active {
  transform: scale(0.98);
}
.line_height_2 {
  line-height: 2rem;
}
@keyframes fadeIn {
  from { opacity: 0; transform: scale(0.9); }
  to { opacity: 1; transform: scale(1); }
}
</style>